
    import '/home/ec2-user/Youlify-Design/docs/spec/motion.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-spec-motion-demo-zh-cn-0"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/home/ec2-user/Youlify-Design/docs/spec/motion.zh-CN.md?type=demo')
};